import type { Coupon, SROW } from '../../../../schema/coupon/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import { NotImplementedError } from '../../error/NotImplementedError.js';
import { getDefinitionReductionSum } from '../coupon/getDefinitionReductionSum.js';
import { getBoardCartesianProducts } from './getCartesianProducts.js';

type Options = {
  definition: Definition;
};

function expandBoardToSROW(board: Coupon['boards'][number], engineReductionSum: number): SROW[] {
  const boardCartesianProducts = getBoardCartesianProducts(board, engineReductionSum);

  const singleRows = boardCartesianProducts.reduce<SROW[]>(
    (srows, eventOutcomeCombinations) =>
      srows.flatMap((srow) => eventOutcomeCombinations.map((outcomes) => [...srow, outcomes])),
    [[]]
  );

  return singleRows;
}

/**
 * Expands given coupon boards to its corresponding SROW (single rows).
 *
 * @param coupon Coupon to expand to SROW collection
 * @param root0 function options
 * @param root0.definition Product definition
 * @returns Array of SROW
 * @throws {NotImplementedError} When the selected system is not implemented
 */
export function expandCouponToSROW(coupon: Coupon, { definition }: Options): SROW[] {
  if (!['MSYS', 'SROW'].includes(coupon.selectedSystem)) {
    throw new NotImplementedError(`System "${coupon.selectedSystem}" not implemented yet`);
  }

  const engineReductionSum = getDefinitionReductionSum(definition);

  const srowCollection: SROW[] = [];
  for (const board of coupon.boards) {
    const srow = expandBoardToSROW(board, engineReductionSum);
    srowCollection.push(...srow);
  }

  return srowCollection;
}
